import { render, staticRenderFns } from "./AccountsView.vue?vue&type=template&id=f2633882&"
import script from "./AccountsView.vue?vue&type=script&lang=js&"
export * from "./AccountsView.vue?vue&type=script&lang=js&"
import style0 from "./AccountsView.vue?vue&type=style&index=0&id=f2633882&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports